
import { Note } from "../../../models/note.model.ts";
import { NoteSerializer } from "../../../models/serializers/noteSerializer.ts";
import { httpRequest } from "../../http";

export class CommandCreateNote {
    async run( notebookId: number, parentId: number | null, title: string, content: string, type: string = 'note' ) {

        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}/pages/`
        try {
            const response = await httpRequest<any>(url, {
                method: "POST",
                body: {
                        parent_id: parentId,
                        title: title,
                        content: content,
                        type: type,
                },
            });
            return this.deserialize(response);
            
        } catch (error) {
            console.error('Error creating note:', error);
            throw error;
        }
    }


    deserialize(data: any) : Note{
        const serializer = new NoteSerializer();
        return serializer.deserialize(data);
    }

}

